var _desc, _defs, _rect, _path, _path2, _path3, _path4, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DevOps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Continuous loop and infrastructure nodes.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10375a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#071d30"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 118c46-36 120-36 168 0",
    fill: "none",
    stroke: "#ffd700",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378 242c-46 36-120 36-168 0",
    fill: "none",
    stroke: "#73c6ff",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M382 118l26 0m-10-12l12 12-12 12",
    stroke: "#ffd700",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206 242l-26 0m10-12l-12 12 12 12",
    stroke: "#73c6ff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0f3d5d",
    stroke: "#8fd5ff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 92,
    width: 86,
    height: 64,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 92,
    width: 86,
    height: 64,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 206,
    width: 86,
    height: 64,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 206,
    width: 86,
    height: 64,
    rx: 10
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 32,
    fill: "#134b70",
    stroke: "#ffd700",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/devops.1c2e48831e0232f5c26f93b18ca61bef.svg";
export { ForwardRef as ReactComponent };